import { ChangeDetectionStrategy, Component, DOCUMENT, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from '@core/services/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class App {
  private readonly document = inject(DOCUMENT);
  private readonly theme = inject(ThemeService);

  constructor() {
    // `/published/**` — страница виджета для конечного пользователя:
    // тема там приходит из publish_options агента, а не из локального
    // предпочтения администратора, поэтому глобальную тему не включаем.
    if (!this.document.location.pathname.startsWith('/published/')) {
      this.theme.enable();
    }
  }
}
